import CreateAccountModel from "../models/CreateAccountModel"


export default class CreateAccountValid{

    public static checkCreateAccount = (data: CreateAccountModel, errorMsg: string, setCreateAccount?:(x: CreateAccountModel)=>void) =>{
        const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;
        const isValidPhoneNumber = /^(?:[+\d].*\d|\d)$/g;
        if(data.email === undefined || data.email === ""){errorMsg = errorMsg + "Please enter email.\n 請輸入電子郵件。 \n"}
        else if(!data.email.match(isValidEmail)){errorMsg = errorMsg + "Please check email format.\n 請檢查電子郵件格式。 \n"}
        if(data.company === undefined || data.company === ""){errorMsg = errorMsg + "Please enter company.\n 請輸入公司名稱。 \n"}
        if(data.phoneNumber === undefined || data.phoneNumber === ""){errorMsg = errorMsg + "Please enter phone number.\n 請輸入電話號碼。 \n"}
        else if(!data.phoneNumber.match(isValidPhoneNumber)){errorMsg = errorMsg + "Please check phone number format.\n 電話號碼應為數字。 \n"}
        if(data.password === undefined || data.password === ""){errorMsg = errorMsg + "Please enter password.\n 請輸入密碼。 \n"}
        return errorMsg
    }
}